var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG4AiIconEtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 35.2829 54.4387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1899 19.1768C24.328 19.1768 28.3518 19.1768 32.3985 19.1768C33.313 19.1768 34.1132 19.4054 34.6847 20.1141C35.4849 21.0972 35.4163 22.126 34.8676 23.2234C32.4899 27.9559 30.1122 32.6885 27.7346 37.4439C25.174 42.5422 22.6362 47.6405 20.0756 52.716C19.3898 54.0877 18.2695 54.6593 17.0349 54.3621C15.7775 54.042 15.0688 53.0589 15.0688 51.6186C15.0688 46.5203 15.0688 41.3991 15.0688 36.3007C15.0688 36.0035 15.0688 35.6834 15.0688 35.2719C14.703 35.2719 14.4057 35.2719 14.0857 35.2719C10.3819 35.2719 6.65537 35.2719 2.95165 35.2719C0.482502 35.2719 -0.683485 33.4201 0.413913 31.2253C5.32934 21.4173 10.2219 11.6093 15.1373 1.80128C15.8461 0.406671 16.9206 -0.210616 18.1323 0.063734C19.4812 0.360946 20.1899 1.38976 20.1899 2.99013C20.1899 8.04273 20.1899 13.0953 20.1899 18.1251C20.1899 18.4452 20.1899 18.7652 20.1899 19.1768ZM15.0688 13.8727C15.0002 13.8498 14.9544 13.8269 14.8859 13.8269C12.1881 19.2225 9.46745 24.618 6.72395 30.1279C10.3819 30.1279 13.8799 30.1279 17.355 30.1279C19.184 30.1279 20.2128 31.1567 20.2128 32.9857C20.2128 35.3176 20.2128 37.6725 20.2128 40.0045C20.2128 40.2102 20.2585 40.3931 20.3043 40.8046C23.0935 35.2033 25.7912 29.8307 28.5576 24.2979C28.1004 24.2979 27.7803 24.2979 27.4831 24.2979C24.3052 24.2979 21.1502 24.2979 17.9723 24.2979C16.0976 24.2979 15.0688 23.2691 15.0688 21.3944C15.0459 18.8795 15.0688 16.3875 15.0688 13.8727Z",
    fill: "var(--fill-0, #EF4223)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4AiIconEtl);
export default __webpack_public_path__ + "static/media/g4ai-icon-etl.2ceb7e95f063a159d8a33cfaa3a20d7f.svg";
export { ForwardRef as ReactComponent };